








































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import fullCalendar from "vue-fullcalendar";
import AuthService from "../services/auth-service";
import moment from "moment";
import lodash from "lodash";

declare var amp: any;

@Component({
  components: {}
})
export default class SubjectSelect extends Vue {
  private service = new GeneralService();
  private apiLoading = false;
  private view = 0;
  private calendarItems: any;
  private currentDay = "";
  private currentSubject = "";
  private currentSubjects = [];
  private weekEvents: any = [];
  private weekClicked: any = [];
  private auth = new AuthService();
  private selectedWeek = 0;
  private player: any;
  private sourceLoaded = false;
  private loadingCalendar = true;

  private isPre2Batch = false;

  private workEvents: any = [];

  private entities = [
    {
      id: 0,
      apiId: "3d0de5a2-cd6d-4b25-80a2-1b00473cfc5a",
      fullName: "I.Com"
    },
    {
      id: 1,
      apiId: "b08cbe37-93dd-4b67-8e64-7d80a0347740",
      fullName: "ICS"
    },
    {
      id: 2,
      apiId: "fc27bb7a-989c-4174-9822-7686fb965a0f",
      fullName: "FSc (Medical)"
    },
    {
      id: 3,
      apiId: "8aa08620-cab9-44f4-b884-d24f0951ef62",
      fullName: "FSc (Engineering)"
    }
  ];

  private entities2 = [
    {
      id: 4,
      apiId: "3d0de5a2-cd6a-4b25-80a2-1b00473cfc5a",
      fullName: "I.Com"
    },
    {
      id: 5,
      apiId: "b08cbe37-93db-4b67-8e64-7d80a0347740",
      fullName: "ICS"
    },
    {
      id: 6,
      apiId: "fc27bb7a-989a-4174-9822-7686fb965a0f",
      fullName: "FSc (Medical)"
    },
    {
      id: 7,
      apiId: "8aa08620-cab4-44f4-b884-d24f0951ef62",
      fullName: "FSc (Engineering)"
    }
  ];

  private goOrientation() {
    this.$router.push("orientation");
  }

   private goLiterary() {
    this.$router.push("pre-literary");
  }

  private tableItems: any = [];
  private selectedWorkItem: any = {};
  private videoKey = 0;
  private currentSubjectName = "";

  private giveDay(x: number) {
    if (x == 1) return "Monday";
    else if (x == 2) return "Tuesday";
    else if (x == 3) return "Wednesday";
    else if (x == 4) return "Thursday";
    else if (x == 5) return "Friday";
    else if (x == 6) return "Saturday";
    else if (x == 0) return "Sunday";
  }

  private isFederal = false;

  private addWeek() {
    if (this.selectedWeek < 11) {
      this.selectedWeek++;
      this.changeWeek(this.selectedWeek);
    }
  }

  private lessWeek() {
    if (this.selectedWeek > 0) {
      this.selectedWeek--;
      this.changeWeek(this.selectedWeek);
    }
  }

  private changeWeek(x: number) {
    for (let i = 0; i < 12; i++) {
      Vue.set(this.weekClicked, i, false);
    }
    Vue.set(this.weekClicked, x, true);
  }

  getUnique(array) {
    return lodash.uniqWith(array, (obj1, obj2) => {
      return obj1.Type === obj2.Type && obj1.CourseId === obj2.CourseId;
    });
  }

  sortArray(array) {
    return array.sort(function(a, b) {
      let nameA = a.CourseId.toLowerCase(),
        nameB = b.CourseId.toLowerCase();
      if (nameA < nameB)
        //sort string ascending
        return -1;
      if (nameA > nameB) return 1;
      return 0; //default return value (no sorting)
    });
  }

  private clickedDay(dayData) {
    if (dayData.isEnable == 1 || this.auth.session.varification == 'Full Access') {
      this.currentDay = dayData.dated.split("T")[0];
      this.tableItems = [];
      if (dayData.video) {
        for (let work of JSON.parse(dayData.video)) {
          this.tableItems.push(work);
        }
      }

      if (dayData.note) {
        for (let work of JSON.parse(dayData.note)) {
          this.tableItems.push(work);
        }
      }

      if (dayData.mcqs) {
        for (let work of JSON.parse(dayData.mcqs)) {
          this.tableItems.push(work);
        }
      }

      localStorage[config.selectedWork] = JSON.stringify(this.tableItems);
      this.$router.push("pre-module-work/" + this.currentDay);
    }
  }

  created() {
    this.onKeyDown = this.onKeyDown.bind(this);
    document.addEventListener("keydown", this.onKeyDown);
  }

  destroyed() {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  onKeyDown(e) {
    switch (e.keyCode) {
      case 39:
        this.addWeek();
        break; // 'a' key
      case 37:
        this.lessWeek();
        break; // 'b' key
    }
  }

  private makeGroups(works) {
    let finalAcc = works.reduce(function(acc, work) {
      let yearWeek = moment(work.dated.split("T")[0]).week();
      let date = moment(work.dated.split("T")[0]).format("L");
      let isPre2Batch = false;
      if (
        localStorage[config.isPre2] &&
        localStorage[config.isPre2] !== "undefined"
      )
        isPre2Batch = JSON.parse(localStorage[config.isPre2]);

      if (date == "05/16/2020" || date == "07/11/2020") {
        work.entry = true;
      }

      if (yearWeek > 16) {
        if (typeof acc[yearWeek - (isPre2Batch ? 19 : 17)] === "undefined") {
          acc[yearWeek - (isPre2Batch ? 19 : 17)] = [];
        }

        acc[yearWeek - (isPre2Batch ? 19 : 17)].push(work);
      }

      return acc;
    }, {});

    return finalAcc;
  }

  private goBack() {
    this.sourceLoaded = false;
    this.videoKey++;
    this.view--;
  }

  getImgUrl(pet) {
    if (pet[pet.length - 1] == ' ') {
        pet = pet.substring(0, pet.length-1);
    }
    const images = require.context("@/assets/images/icons/", false, /\.svg$/);
    try {
      return images("./" + pet + ".svg");
    } catch {
      // return images('./error.png')
    }
  }

  private selectSubject(id: string, name: string, state: boolean) {
    this.currentSubject = id;
    this.isFederal = state;
    this.loadingCalendar = true;
    this.currentSubjectName = name;
    this.view = 1;
    localStorage[config.classLevl] = id;
    localStorage[config.selectedSubjectName] = name;
    localStorage[config.classState] = state;

    this.service
      .getWork(this.currentSubject, this.isPre2Batch ? 2 : 1)
      .then(response => {
        this.view = 1;
        this.loadingCalendar = false;
        this.workEvents = response;
        this.weekClicked = [];
        this.selectedWeek = 0;
        let currentWeek =
          moment(new Date()).week() - (this.isPre2Batch ? 19 : 17);
        if (currentWeek >= 0 && currentWeek < 12) {
          Vue.set(this.weekClicked, currentWeek, true);
          this.selectedWeek = currentWeek;
        } else {
          Vue.set(this.weekClicked, 0, true);
          this.selectedWeek = 0;
        }
        this.weekEvents = this.makeGroups(this.workEvents);
      });
  }

  mounted() {
    if (!this.auth.session) {
      this.$router.push("/");
    }

    if (
      localStorage[config.isPre2] &&
      localStorage[config.isPre2] !== "undefined"
    )
      this.isPre2Batch = JSON.parse(localStorage[config.isPre2]);

    if (
      localStorage[config.classLevl] !== "null" &&
      localStorage[config.classLevl] !== "undefined"
    ) {
      this.selectSubject(
        localStorage[config.classLevl],
        localStorage[config.selectedSubjectName],
        JSON.parse(localStorage[config.classState])
      );
    }

    let today = moment().format("LL");

    // if (localStorage[config.firstLogin] !== today && !this.isPre2Batch) {
    //   this.$bvModal.show("popup-message");
    //   localStorage[config.firstLogin] = today;
    // }

    // if (localStorage[config.userLogCheck]){
    //   let idCheck = localStorage[config.userLogCheck];
    //   let infoArray = idCheck.split('_');
    //   if (infoArray[0] !== today || infoArray[1] !==this.auth.session.userId){
    //     this.service.userLog().then(response => {
    //       localStorage[config.userLogCheck] = today + '_' + this.auth.session.userId;
    //     });
        
    //   }
    // } else {
    //   this.service.userLog().then(response => {
    //     localStorage[config.userLogCheck] = today + '_' + this.auth.session.userId;
    //   });
    // }
  }
}
